import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getStations = async (stationFilter) => {
    const urlParams = createUrlParams(stationFilter)
    const url = `/api/v1/geo/stations?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getModel1Stations = async (model1Filter) => {
    const urlParams = createUrlParams(model1Filter)
    const url = `/api/v1/geo/model1_stations?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getModel23Stations = async (model23Filter) => {
    const urlParams = createUrlParams(model23Filter)
    const url = `/api/v1/geo/model23_stations?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getMicroZones = async (microZoneFilter) => {
    const urlParams = createUrlParams(microZoneFilter)
    const res = await axios.get(`/api/v1/geo/micro_zones?${urlParams.toString()}`);
    return res.data;
}

export const getMicroZonesModel1AggregatedData = async (microZoneFilter) => {
    const urlParams = createUrlParams(microZoneFilter)
    const res = await axios.get(`/api/v1/geo/micro_zones/model1_aggregated_data?${urlParams.toString()}`);
    return res.data;
}

export const getIncidents = async (incidentsFilter) => {
    const urlParams = createUrlParams(incidentsFilter)
    const res = await axios.get(`/api/v1/geo/incidents?${urlParams.toString()}`);
    return res.data;
}

export const getModels23 = async (models23Filter) => {
    const urlParams = createUrlParams(models23Filter)
    const res = await axios.get(`/api/v1/geo/models23?${urlParams.toString()}`);
    return res.data;
}